import { createCellCheckbox } from '../components/feature/checkbox'
import { getRowKeyIter } from '../store/config/utils'
import '../style/custom-cell.scss'
import '../style/radio.scss'
const CHECKBOX_KEY_PREFIX = 'CHECKBOX_'
const RADIO_KEY_PREFIX = 'RADIO_'
const CUSTOM__ROW_CELL_CLASS = 'virtual-grid__inner__table__custom__row__cell'
const CUSTOM_HEADER_CELL_CLASS = 'virtual-grid__inner__table__custom__header__cell'

export function getCustomRowCellAlignClass (column) {
  const { align, textAlign } = column
  const className = align || textAlign ? CUSTOM__ROW_CELL_CLASS + '__' + (align || textAlign) : ''
  const classes = [CUSTOM__ROW_CELL_CLASS, className]
  return classes.filter(Boolean)
}

export function getCustomHeaderCellAlignClass (column) {
  const { align, textAlign } = column
  const className = align || textAlign ? CUSTOM_HEADER_CELL_CLASS + '__' + (align || textAlign) : ''
  const classes = [CUSTOM_HEADER_CELL_CLASS, className]
  return classes.filter(Boolean)
}

export const COLUMNS_INDEX = {
  label: '序号',
  key: '_index',
  sortable: false,
  resizable: true,
  width: 40,
  isInternal: true,
  align: 'left',
  _internal: true,
  headerCellRender: function(h, { column }) {
    const classes = getCustomHeaderCellAlignClass(column)
    return <div class={classes}>{column.label || '#'}</div>
  },
  rowCellRender: function (h, { _index, fixedRowsTop = 0, column }) {
    const index = _index
    let i = typeof index === 'number' ? index + fixedRowsTop : index
    if (isNaN(i)) {
      i = ''
    }
    const classes = getCustomRowCellAlignClass(column)
    return <div class={classes}>{ i }</div>
  },
}

export function updateColumnsIndexWidth(fixedColumnsOnLeft = [], tableDataLength) {
  const showIndexColumn = fixedColumnsOnLeft.find(item => item.key === COLUMNS_INDEX.key)
  let indexCol = String(tableDataLength).length * 10
  const width = indexCol < COLUMNS_INDEX.width ? COLUMNS_INDEX.width : indexCol
  if (showIndexColumn && width > COLUMNS_INDEX.width && width !== showIndexColumn.width) {
    showIndexColumn.width = width
  }
}

const CellCheckbox = createCellCheckbox()

export const COLUMNS_SELECTION = {
  headerCellRender: function (h, { store, column }) {
    const { selectionHeaderRenderToLeft, selectionHeaderRenderToRight } = column
    const rowKey = store.table.$props.rowKey
    const key = CHECKBOX_KEY_PREFIX + column.key
    const reserveSelection = store.table.$props.reserveSelection
    const _checkboxDataLength = (store._checkboxData || []).length
    const disableHeadCheckbox = store.table.$props.disableHeadCheckbox
    const disabled = disableHeadCheckbox || !_checkboxDataLength
    const classes = getCustomHeaderCellAlignClass(column)
    const render = cb => {
      return (
        <div class={classes}>
          {selectionHeaderRenderToLeft ? selectionHeaderRenderToLeft(h, opt) : ''}
          {cb()}
          {selectionHeaderRenderToRight ? selectionHeaderRenderToRight(h, opt) : ''}
        </div>
      )
    }
    // 保留历史的多选按钮
    if (reserveSelection) {
      // 判断当前数据是否都被选中
      const selectedIter = rowData => store.selection.has(getRowKeyIter(rowData, rowKey))
      const hasTableData = store._tableData.length
      const allSelected = hasTableData && store._tableData.every(selectedIter)
      // 判断是否存在选中数据
      const indeterminate = hasTableData && store._tableData.some(selectedIter)
      const checkboxNode = () => (
        <el-checkbox
          key={key}
          disabled={disabled}
          indeterminate={!allSelected && (store.states.selectOnIndeterminate || !!indeterminate)}
          on-input={val => store.toggleAllSelection(val ? allSelected : val)}
          value={allSelected}
        />
      )
      return render(checkboxNode)
    } else {
      const selectionSize = store.selection.size
      const _checkboxDataLength = store._checkboxData.length
      const indeterminate = !!selectionSize && selectionSize !== _checkboxDataLength
      const allSelected = selectionSize === _checkboxDataLength
      const checkboxNode = () => (
        <el-checkbox
          key={key}
          disabled={disabled}
          indeterminate={store.states.selectOnIndeterminate || indeterminate}
          on-input={val => store.toggleAllSelection(val ? allSelected : val)}
          value={store.states.isAllSelected && allSelected}
        />
      )
      return render(checkboxNode)
    }
  },
  rowCellRender: function (h, opt = {}) {
    const {
      rowData,
      column,
      selectable,
      rowIndex,
      isAllSelected,
      UPDATE_checkbox,
      rowSelectedChanged,
      rowKey,
      getSelection,
      showSelection
    } = opt
    const { selectionRenderToLeft, selectionRenderToRight } = column

    const uniqueId = getRowKeyIter(rowData, rowKey)
    const key = CHECKBOX_KEY_PREFIX + uniqueId

    const classes = getCustomRowCellAlignClass(column)
    return showSelection !== false ? (
      <div class={classes}>
        {selectionRenderToLeft ? selectionRenderToLeft(h, opt) : ''}
        <CellCheckbox
          rowData={rowData}
          key={key}
          rowIndex={rowIndex}
          uniqueId={uniqueId}
          selectable={selectable}
          isAllSelected={isAllSelected}
          UPDATE_checkbox={UPDATE_checkbox}
          rowSelectedChanged={rowSelectedChanged}
          getSelection={getSelection}></CellCheckbox>
        {selectionRenderToRight ? selectionRenderToRight(h, opt) : ''}
      </div>
    ) : null
  },
  key: '_selection',
  _internal: true,
  sortable: false,
  resizable: true,
  isInternal: true,
  className: 'table2_checkbox',
  align: 'center',
  width: 40
}
export const COLUMNS_RADIO = {
  headerCellRender: function (h, {store, column}) {
    return <div></div>
  },
  rowCellRender: function (h, {
    rowData,
    column,
    rowIndex,
    columnIndex,
    rowKey,
    showRadio,
    setRadioSelectedInRows,
    getRadioSelected,
    radioProps
  }) {
    const uniqueId = getRowKeyIter(rowData, rowKey)
    const key = RADIO_KEY_PREFIX + uniqueId
    const classes = getCustomRowCellAlignClass(column)
    const value = getRadioSelected()
    const change = () => {
      setRadioSelectedInRows(uniqueId, rowData)
    }
    const { disabled } = radioProps || {}
    const _disabled = typeof disabled === 'function' ? disabled({rowData, column, rowIndex, columnIndex}) : disabled
    const radioAttrs = {
      props: {
        ...(radioProps || {}),
        disabled: _disabled,
        value,
        label: uniqueId
      },
      on: {
        change
      },
      key
    }
    const children = '&nbsp;'
    classes.push('table2-radio')
    return showRadio !== false ? <div class={classes}>
      <kye-radio
        {...radioAttrs}
      >
        {children}
      </kye-radio>
    </div> : null
  },
  key: '_radio',
  _internal: true,
  sortable: false,
  resizable: true,
  isInternal: true,
  align: 'center',
  width: 40,
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/config/columns.js